export default function timestamp () {
  /**
   * Get the current date/time in seconds size epoch (rather than milliseconds as default in JS).
   */
  return Math.floor(Date.now() / 1000)
}
